// src/components/sidebar-widgets/JobMatchesCard.jsx
import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import {
  SIDEBAR_WIDGET_BORDER_COLOR,
  SIDEBAR_WIDGET_CARD_SX,
  SIDEBAR_WIDGET_TITLE_SX,
} from "./sidebarWidgetStyles";

const BORDER = SIDEBAR_WIDGET_BORDER_COLOR;
const CARD_BG = "#FFFFFF";
const PURPLE = "#9C4FFF";
const MUTED = "#94A3B8";
const TEXT = "#111827";
const SUB = "#9CA3AF";

function HeaderRow() {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 70px 60px",
        alignItems: "center",
        mt: 1.25,
        mb: 0.75,
      }}
    >
      <Typography sx={{ fontSize: 11, color: MUTED, fontWeight: 400 }}>Job</Typography>
      <Typography sx={{ fontSize: 11, color: MUTED, fontWeight: 400, textAlign: "center" }}>
        Match (%)
      </Typography>
      <Typography sx={{ fontSize: 11, color: MUTED, fontWeight: 400, textAlign: "right" }}>
        Applied
      </Typography>
    </Box>
  );
}

function MatchRow({ item, onClick }) {
  return (
    <Box sx={{ py: 1.1 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 70px 60px",
          alignItems: "center",
          columnGap: 1,
        }}
      >
        {/* left */}
        <Box sx={{ minWidth: 0 }}>
          <Typography
            onClick={() => onClick?.(item)}
            sx={{
              fontSize: 12,
              color: PURPLE,
              fontWeight: 400,
              cursor: "pointer",
              userSelect: "none",
              lineHeight: 1.25,
            }}
          >
            {item.title}
          </Typography>
          <Typography sx={{ fontSize: 11, color: SUB, fontWeight: 400, lineHeight: 1.2 }}>
            {item.company}
          </Typography>
        </Box>

        {/* match */}
        <Typography sx={{ fontSize: 12, color: TEXT, fontWeight: 400, textAlign: "center" }}>
          {item.match}
        </Typography>

        {/* applied */}
        <Typography sx={{ fontSize: 12, color: TEXT, fontWeight: 400, textAlign: "right" }}>
          {item.applied ? "Yes" : "No"}
        </Typography>
      </Box>
    </Box>
  );
}

export default function JobMatchesCard({
  title = "Job matches",
  items = [],
  onRowClick,
  onViewAll,
  sx = {},
}) {
  return (
    <Box
      sx={{
        ...SIDEBAR_WIDGET_CARD_SX,
        background: CARD_BG,
        mb: "28px",
        ...sx,
      }}
    >
      {/* header */}
      <Box sx={{ px: 4, pt: 4, pb: 1.25 }}>
        <Typography sx={SIDEBAR_WIDGET_TITLE_SX}>
          {title}
        </Typography>

        <HeaderRow />
      </Box>

      {/* list */}
      <Box sx={{ px: 4, pb: 2 }}>
        {!items.length ? (
          <Typography sx={{ py: 2, fontSize: 12, color: MUTED }}>
            No job matches found.
          </Typography>
        ) : null}
        {items.map((it, idx) => (
          <React.Fragment key={it.id || idx}>
            <MatchRow item={it} onClick={onRowClick} />
            {idx !== items.length - 1 && <Divider sx={{ borderColor: BORDER }} />}
          </React.Fragment>
        ))}

        {/* footer link */}
        <Box sx={{ pt: 1.25, pb: 1.75, display: "flex", justifyContent: "center" }}>
          <Typography
            onClick={() => onViewAll?.()}
            sx={{
              fontSize: 12,
              color: PURPLE,
              fontWeight: 400,
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            View all Matches
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
